import Vue from 'vue'
import SweetModal from 'sweet-modal-vue/src/plugin.js'
Vue.use(SweetModal)
